// ScenarioDescription
import React, { Dispatch, MouseEvent, useState, useEffect, useRef } from 'react';
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom'
import { startHotwash } from '../../features/player/gameSlice'
import { updateHotwashSelection } from '../../features/hotwash/hotwashSlice'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { fetchImages, deleteScenario, copyScenario } from '../../features/scenarioSlice'
import { getHotwashesByScenarioId } from '../../features/hotwash/hotwashSlice'
import { HostSelection, NewHostSelection } from '../../Classes1';
import { IScenario, IGameStatus, IHotwash, IPlayer } from '../../interfaces';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import _ from 'lodash';

interface ScenarioDescriptionProps {
    showScenarioPage: string;
    toggleScenarioPage: Dispatch<any>;
    setShowScenarioPage: Dispatch<any>;
    gameScenario: IScenario;
    games: IGameStatus[];
    setShowScenarioHideHome: Dispatch<any>;
  }

const ScenarioDescription: React.FC<ScenarioDescriptionProps> = ({ showScenarioPage, toggleScenarioPage, gameScenario, setShowScenarioPage, games, setShowScenarioHideHome }) => {
    
    const customStyles = {
        content: {
          background: '#323544',
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          padding: '0',
          border: 'none',
          width: '480px',
          transform: 'translate(-50%, -50%)',
        }
      };

      const customHotwashStyles = {
        content: {
          background: '#323544',
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          padding: '0',
          border: 'none',
          width: '640px',
          transform: 'translate(-50%, -50%)',
        }
      };

    const [hotwashGames, setHotwashGames] = useState<IGameStatus[]>([])
    const [hotwashes, setHotwashes] = useState<IHotwash[]>([])
    const [hotwashModalIsOpen, setHotwashModalIsOpen] = useState<boolean>(false);
    const [imageUrls, setImageUrls] = useState<any[]>([{url: 'img/loading-500x258.gif'}]); 
    const [deleteScenarioModalIsOpen, setDeleteScenarioModalIsOpen] = useState<boolean>(false);
    const [cannotDeleteModalIsOpen, setCannotDeleteModalIsOpen] = useState<boolean>(false);
    const [copyScenarioModalIsOpen, setCopyScenarioModalIsOpen] = useState<boolean>(false);
    const [isScenarioCopied, setIsScenarioCopied] = useState<boolean>(false);
    const [isScenarioDeleted, setIsScenarioDeleted] = useState<boolean>(false);
    const [hotwashListTop, setHotwashListTop] = useState<number>(0)
    const [hotwashSelection, setHotwashSelection] = useState<string>('')
    const [hotwashGameId, setHotwashGameId] = useState<string>('')
    const [hotwashIsSelected, setHotwashIsSelected] = useState<boolean>(false)
    const [copiedScenarioId, setCopiedScenarioId] = useState<string>('')
    const [copyScenarioLoading, setCopyScenarioLoading] = useState<boolean>(false)
    const [deleteScenarioLoading, setDeleteScenarioLoading] = useState<boolean>(false)
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const navigate = useNavigate()
    const dispatch: any = useAppDispatch();

    const user = useAppSelector((state) => state.auth.userId)

    const carouselImgsRef = useRef<NodeListOf<Element>>()

    useEffect(() => {
        async function asyncCall() {
          let hotwashes: any = await dispatch(getHotwashesByScenarioId(gameScenario.id))
          setHotwashes(hotwashes.payload)
        }
        asyncCall()
      }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (carouselImgsRef.current === undefined) {
            carouselImgsRef.current = document.querySelectorAll('.scenario-carousel-img')
        }
        if (carouselImgsRef.current !== undefined) {
            carouselImgsRef.current = document.querySelectorAll('.scenario-carousel-img')
            if (carouselImgsRef.current!.length === gameScenario.images.length) {
                
                const onImageLoaded = (img: any) => {
                    if (img.target.height > img.target.width) {
                        img.target.style.width = 'auto';
                        img.target.style.height = '261px';
                    } else if (img.target.height < img.target.width) {
                        img.target.style.maxWidth = '392px';
                    }
                };
                for (let i = 0; i<carouselImgsRef.current.length; i++) {

                    let currImage = carouselImgsRef.current[i] as HTMLImageElement
                    
                    if (currImage) {
                        currImage.addEventListener('load', onImageLoaded);
                    }
                }
                
            }
        }
    }, [gameScenario.images.length, carouselImgsRef.current]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        async function getImagesAsync() {
          if (!_.isEmpty(gameScenario.id)) {
            if (process.env.REACT_APP_IMAGE_SRC === 'cloud') {
                let gotImages: any = await dispatch(fetchImages(gameScenario.id))
                setImageUrls(gotImages.payload)
            } else {
                if (!_.isEmpty(gameScenario.localImages)) {
                    setImageUrls([{url: 'data:image/png;base64, ' + gameScenario.localImages[0]}])
                } else {
                    setImageUrls([{url: 'img/scenario1.png'}])
                }
            }
          }
        }
        
        getImagesAsync();
    }, [gameScenario.id, dispatch, gameScenario.localImages])

    const closeHotwashModal = () => {
        setHotwashModalIsOpen(false);
    }

    const openHotwashModal = () => {
        setHotwashModalIsOpen(true);
    }

    const openDeleteScenarioModal = () => {
        setDeleteScenarioModalIsOpen(true);
    }
    
    const closeDeleteScenarioModal = () => {
        setDeleteScenarioModalIsOpen(false);
        setCannotDeleteModalIsOpen(false);
    }

    const closeDeleteScenarioModalBtn = () => {
        setDeleteScenarioModalIsOpen(false);
    }
    
    const openCopyScenarioModal = () => {
        setCopyScenarioModalIsOpen(true);
    }

    const closeCopyScenarioModal = () => {
        setCopyScenarioModalIsOpen(false);
    }

    const showHotwashList = (ev: MouseEvent) => {
        ev.stopPropagation();

        const target = ev.currentTarget as HTMLButtonElement;

        if (target) {
            let scenGames: IGameStatus[] = [];
            let inGames: IGameStatus[] = JSON.parse(JSON.stringify(games));
            for (let i = 0; i<inGames.length; i++) {
                if (inGames[i].scenarioId === gameScenario.id && inGames[i].completed === true) {
                    let newGame: IGameStatus = inGames[i];
                    newGame.selected = '';
                    scenGames.push(newGame);
                }
            }

            setHotwashGames(scenGames);
            openHotwashModal();
        }
    }

    const closeScenarioBtn = (ev: MouseEvent) => {
        ev.stopPropagation();

        setShowScenarioPage('')
        setShowScenarioHideHome('')
    }

    const loadHotwashBtn = async (ev: MouseEvent) => {
        ev.stopPropagation();

        if (!hotwashIsSelected) return;

        const target = ev.currentTarget as HTMLButtonElement;

        if (target) {
            if (hotwashSelection !== "1") {
                let startHotwashResponse = await dispatch(startHotwash(hotwashGameId))
                let newHostSelection1 = new NewHostSelection();
                newHostSelection1.hotwashId = startHotwashResponse.payload.gameId;
                newHostSelection1.hostSelection = new HostSelection();
                
                newHostSelection1.hostSelection.page = '';
                newHostSelection1.hostSelection.turn = 1;
                newHostSelection1.hostSelection.inject = -1;
                newHostSelection1.hostSelection.node = '';
                newHostSelection1.hostSelection.nodeTab = '';
                newHostSelection1.hostSelection.nodePlayerID = '';
                await dispatch(updateHotwashSelection(newHostSelection1))
                navigate('/hotwash?gameid=' + startHotwashResponse.payload.gameId)
            } else {
                if (!_.isEmpty(hotwashGameId)) {
                    navigate('/hotwash?gameid=' + hotwashGameId)
                } 
            }
        }
    }

    const clickHotwashBtn = async (ev: MouseEvent) => {
        ev.stopPropagation();

        const target = ev.currentTarget as HTMLButtonElement;

        if (target) {
            let selectedHotwashGames: any = JSON.parse(JSON.stringify(hotwashGames));
            for (let i = 0; i<selectedHotwashGames.length; i++) {
                setHotwashSelection(target.dataset.hotwashselection!)
                setHotwashGameId(target.dataset.gameid!)
                selectedHotwashGames[i].selected = ''
                if (selectedHotwashGames[i].gameId === target.dataset.gameid) {
                    selectedHotwashGames[i].selected = 'selected'
                    setHotwashIsSelected(true)
                }
            }
            setHotwashGames(selectedHotwashGames)
        }
    }

    const addDefaultSrc = (ev: any) => {
        ev.target.src = 'img/loading-500x258.gif'
    }

    const hotwashPagePrev = () => {
        if (hotwashGames.length > 5) {
            setHotwashListTop(0)
        }
    }

    const hotwashPageNext = () => {
        if (hotwashGames.length > 5) {
            setHotwashListTop(-290)
        }
    }

    const clickEdit = async () => {
        if (user === gameScenario.owner || gameScenario.sharedWith.includes(user!)) {
            navigate('/scenariocreator?scenarioid=' + gameScenario.id + '&showpanel=timeline', { replace: false })
        } else {
            openCopyScenarioModal()
        }
    }

    const copyScenarioBtn = async () => {

        if (copyScenarioLoading) {
            return;
        }

        setCopyScenarioLoading(true)

        let copyScenarioResp = await dispatch(copyScenario(gameScenario.id))
        if (copyScenarioResp.payload.id !== undefined) {
            setIsScenarioCopied(true)
            setCopyScenarioLoading(false)
            setCopiedScenarioId(copyScenarioResp.payload.id)
        }
    }

    const clickDelete = async () => {
        if (games.some(g => g.scenarioId === gameScenario.id)) {
            setCannotDeleteModalIsOpen(true);
            return;
        }
        openDeleteScenarioModal()
    }

    const deleteScenarioBtn = async () => {
        if (deleteScenarioLoading) {
            return;
        }

        setDeleteScenarioLoading(true)
        let deleteScenarioResp = await dispatch(deleteScenario(gameScenario.id))
        if (deleteScenarioResp.meta.requestStatus === 'fulfilled') {
            setDeleteScenarioLoading(false)
            setIsScenarioDeleted(true)
        }
    }

    const getRuns = () => {
        
        let runs: number = 0;
        let runArray: Date[] = [];
        for (let i = 0; i<games.length; i++) {
            if (games[i].players.filter((player: IPlayer) => player.userID === user).length > 0 && games[i].scenarioId === gameScenario.id) {
                runs++
                runArray.push(games[i].completeDate)
            }
        }

        return runs;
    }

    const getLastRunDate = () => {
        
        let runArray: Date[] = [];
        for (let i = 0; i<games.length; i++) {
            if (games[i].players.filter((player: IPlayer) => player.userID === user).length > 0 && games[i].scenarioId === gameScenario.id) {
                runArray.push(new Date(games[i].completeDate))
            }
        }

        let lastRunDate: Date = new Date(runArray.sort((a: Date, b: Date) => a.getTime() - b.getTime()).pop()!);
        
        let lastRunDateStr: string = '-'
        
        lastRunDateStr = monthNames[lastRunDate.getMonth()] + ' ' + lastRunDate.getDate() + ', ' + lastRunDate.getFullYear()

        if (lastRunDateStr.indexOf('undefined') !== -1 && lastRunDateStr.indexOf('NaN') !== -1) {
            lastRunDateStr = '-'
        }

        return lastRunDateStr;
    }

    return (
        <div className="scenario-page">
            <img className="scenario-x" src="img/grey-x.svg" onClick={closeScenarioBtn} alt="open scenario page" />
            <div className="scenario-page-title">{ _.isEmpty(gameScenario.name) ? 'Unnamed Scenario' : gameScenario.name }</div>
            <div className="scenario-page-subtitle">{gameScenario.description}</div>
            <div className="scenario-page-media">
            <div className="scenario-carousel">
                <Carousel showThumbs={false} showStatus={false}>
                    {!_.isEmpty(imageUrls) ? imageUrls.map((img: any, i: number) => {
                        if (img.url !== '') {
                            return ( <img src={img.url} alt="" className="scenario-carousel-img" key={i} onError={addDefaultSrc} /> )
                        } else {
                            return ( <img src="img/scenario1.png" alt="" className="scenario-carousel-img" key={i} /> )
                        }  
                    }) : [<img src="img/scenario1.png" alt="" className="scenario-carousel-img" key={0} />]}
                </Carousel>
            </div>
                
                <div className="scenario-page-details">
                    <div className="scenario-page-details-inner">
                        <div className="scenario-page-details-labels">
                            <div className="scenario-page-details-row">
                                <div className="scenario-page-details-label">Turns</div>
                                <div className="scenario-page-details-text"><img src="img/player-clock.svg" className="scenario-page-icon" alt="" />{gameScenario.gameTimeInterval}</div>
                            </div>
                            
                            <div className="scenario-page-details-row">
                                <div className="scenario-page-details-label">Roles</div>
                                <div className="scenario-page-details-text">{gameScenario.roles.map((role: any, i: number) => {
                                    if (i < gameScenario.roles.length-1) {
                                        return role+', ';
                                    } else {
                                        return role;
                                    }
                                })}</div>
                            </div>
                            <div className="scenario-page-details-row">
                                <div className="scenario-page-details-label">Your Runs</div>
                                <div className="scenario-page-details-text">{getRuns()}</div>
                            </div>
                            <div className="scenario-page-details-row">
                                <div className="scenario-page-details-label">Your Last Run</div>
                                <div className="scenario-page-details-text">{getLastRunDate()}</div>
                            </div>
                            <div className="scenario-page-details-row">
                                <div className="scenario-page-details-label">Topic Tags</div>
                                <div className="scenario-page-details-text">{gameScenario.tagsTopic.map((tag: any, i: number) => {
                                    if (i < gameScenario.tagsTopic.length-1) {
                                        return <span key={tag} title={tag.length > 15 ? tag : undefined}>{tag},&nbsp;</span>
                                    } else {
                                        return <span key={tag} title={tag.length > 15 ? tag : undefined}>{tag}</span>;
                                    }
                                } )}</div>
                            </div>
                            <div className="scenario-page-details-row">
                                <div className="scenario-page-details-label">Location Tags</div>
                                <div className="scenario-page-details-text">{gameScenario.tagsLocation.map((tag: any, i: number) => {
                                    if (i < gameScenario.tagsLocation.length-1) {
                                        return <span key={tag} title={tag.length > 15 ? tag : undefined}>{tag},&nbsp;</span>
                                    } else {
                                        return <span key={tag} title={tag.length > 15 ? tag : undefined}>{tag}</span>;
                                    }
                                } )}</div>
                            </div>
                            <div className="scenario-page-details-row">
                                <div className="scenario-page-details-label">Details Tags</div>
                                <div className="scenario-page-details-text">{gameScenario.tagsDetails.map((tag: any, i: number) => {
                                    if (i < gameScenario.tagsDetails.length-1) {
                                        return <span key={tag} title={tag.length > 15 ? tag : undefined}>{tag},&nbsp;</span>
                                    } else {
                                        return <span key={tag} title={tag.length > 15 ? tag : undefined}>{tag}</span>;
                                    }
                                } )}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="scenario-page-text">
            {
                //gameScenario.description
            }
            </div>
            <div className={`scenario-description-footer ${gameScenario.owner === user ? '' : 'not-host'} ${hotwashes.length > 0 ? '' : 'no-hotwashes'}`}>
                <div className="scenario-footer-item cancel" onClick={closeScenarioBtn}><div className="scenario-footer-item-text">Cancel</div></div>
                {gameScenario.owner === user ? <div className="scenario-footer-item grey-action" data-name={gameScenario.name} data-scenarioid={gameScenario.id} onClick={clickDelete}><div className="scenario-footer-item-text">Delete</div></div>:<></>}
                {hotwashes.length > 0 ? <div className="scenario-footer-item grey-action" onClick={showHotwashList}><div className="scenario-footer-item-text">View Hot Washes</div></div>: <></>}
                <div className="scenario-footer-item grey-action" onClick={clickEdit} data-scenarioid={gameScenario.id}><div className="scenario-footer-item-text">Edit</div></div>
                <div className="scenario-footer-item action" onClick={toggleScenarioPage} data-type="host" data-scenarioid={gameScenario.id}><div className="scenario-footer-item-text">Start</div></div>
            </div>

            <Modal
                isOpen={hotwashModalIsOpen}
                onRequestClose={closeHotwashModal}
                style={customHotwashStyles}
                contentLabel="Failed Host Modal"
            >
                
                <div className="hotwash-list">
                    <div className="hotwash-list-title">Hot washes <img src="/img/light-grey-x.svg" className="hotwash-list-close" alt="x" onClick={closeHotwashModal}></img></div>
                    <div className="hotwash-list-text">Select a hot wash to view</div>
                        <div className="hotwash-list-wrapper">
                            <div className="hotwash-list-inner" style={{ top: hotwashListTop + 'px' }}>
                                {hotwashGames.map((game: IGameStatus, i: number) => {
                                    return (<div className={`hotwash-list-item ${game.selected}`} key={i} onClick={clickHotwashBtn} data-gameid={game.gameId} data-hotwashselection={game.hotwashSelection} >
                                        <div className="hotwash-list-item-title">{game.name}</div>
                                        <div className="hotwash-list-item-text">
                                            <div className="hotwash-list-item-datetime">{new Date(game.completeDate).toLocaleString()}</div>
                                            <div className="hotwash-list-item-details">{`${game.players.length} Participants (${game.players.map((p, idx) => {
                                                if (game.players.length > 1 && idx >= game.players.length-1) {
                                                    return ' '+p.role
                                                }
                                                return p.role
                                            })})`}</div>
                                        </div>
                                    </div>)
                                })}
                            </div>
                        </div>
                </div>

                <div className="hotwash-pagination">
                    <div className="hotwash-pagination-label">Page 1</div>
                    <img className="hotwash-pagination-left" src="/img/left-arrow.svg" alt="left" onClick={hotwashPagePrev}></img>
                    <img className="hotwash-pagination-right" src="/img/right-arrow-off-white.svg" alt="right" onClick={hotwashPageNext}></img>
                </div>

                <button onClick={closeHotwashModal} className="cancel-hotwash-btn">
                    <span>Cancel</span>
                </button>
                <button onClick={loadHotwashBtn} className={`view-hotwash-btn ${hotwashIsSelected ? 'selected' : ''}`}>
                    <span>View</span>
                </button>
            </Modal>
            <Modal
                isOpen={cannotDeleteModalIsOpen}
                onRequestClose={closeDeleteScenarioModal}
                contentLabel="Error"
                style={customStyles}
            >
                <div className="new-modal-header">Scenario Active <img src="/img/light-grey-x.svg" className="new-modal-padding-close" alt="x" onClick={closeDeleteScenarioModal}></img></div>
                <div className="new-modal-text">Scenario is being used in active games. Please clear out all active games and try again.</div>
                <button onClick={closeDeleteScenarioModal} className="new-cancel-btn"><span>OK</span></button>
            </Modal>
            <Modal
                isOpen={deleteScenarioModalIsOpen}
                onRequestClose={closeDeleteScenarioModal}
                style={customStyles}
                contentLabel="Delete Game Modal"
            >
                {!isScenarioDeleted ? <div className="new-modal-header">Delete Scenario? <img src="/img/light-grey-x.svg" className="new-modal-padding-close" alt="x" onClick={closeDeleteScenarioModal}></img></div> : 
                <div className="new-modal-header">Scenario Deleted <img src="/img/light-grey-x.svg" className="new-modal-padding-close" alt="x" onClick={closeDeleteScenarioModal}></img></div>}
                
                {!isScenarioDeleted ? <div className="new-modal-text"><span className="modal-scenario-name">{gameScenario.name}</span> will be removed from the Scenario Library and deleted. You cannot undo this action</div> : 
                <div className="new-modal-text">The scenario, <span className="modal-scenario-name">{gameScenario.name}</span>, has been deleted successfully.</div>}

                {!isScenarioDeleted ? <button onClick={closeDeleteScenarioModalBtn} className="new-cancel-btn"><span>Cancel</span></button> : <></>}
                {isScenarioDeleted ? <button onClick={event =>  window.location.href='/player'} className="new-confirm-btn done"><span>Done</span></button> : <button onClick={deleteScenarioBtn} className={`new-confirm-btn ${deleteScenarioLoading ? 'start-loading' : ''}`}>
                    {deleteScenarioLoading ? <div className="game-save-loader-25"></div> : <></> }
                    <span>Delete</span>
                </button>}
            </Modal>

            <Modal
                isOpen={copyScenarioModalIsOpen}
                onRequestClose={closeCopyScenarioModal}
                style={customStyles}
                contentLabel="Copy Scenario Modal"
            >
                <div className="new-modal-header">Copy Scenario? <img src="/img/light-grey-x.svg" className="new-modal-padding-close" alt="x" onClick={closeCopyScenarioModal}></img></div>
                
                {!isScenarioCopied ? <div className="new-modal-text"><span className="modal-scenario-name">{gameScenario.name}</span> is not yours to edit. Do you wish to copy this scenario to your Scenario Library for you to edit?</div> : 
                <div className="new-modal-text"><span className="modal-scenario-name">{gameScenario.name}</span> was successfully copied to your Scenario Library.</div>}

                {!isScenarioCopied ? <button onClick={closeCopyScenarioModal} className="new-cancel-btn"><span>Cancel</span></button> : <></>}
                {isScenarioCopied ? <button onClick={event =>  window.location.href='/scenariocreator?scenarioid='+copiedScenarioId}className="new-confirm-btn done"><span>Done</span></button> : <button onClick={copyScenarioBtn} className={`new-confirm-btn ${copyScenarioLoading ? 'start-loading' : ''}`}>
                    {copyScenarioLoading ? <div className="game-save-loader-25"></div> : <></> }
                    <span>Copy</span>
                </button>}
            </Modal>

        </div>
    )
}

export default ScenarioDescription;